import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import { FormattedMessage } from 'react-intl';

import Heading from '../../Heading';
import Amount from '../../Amount';

import BackIcon from '../../../icons/back.svg';

import styles from './NavBar.styl';

const cx = classNames.bind(styles);

class NavBar extends PureComponent {
  static defaultProps = {
    className: '',
    totalPrice: 0,
  };

  static propTypes = {
    className: PropTypes.string,
    totalPrice: PropTypes.number,
    backText: PropTypes.string.isRequired,
    onBack: PropTypes.func.isRequired,
  };

  render() {
    const { totalPrice } = this.props;

    return (
      <div className={cx('NavBar', this.props.className)}>
        <Heading className={cx('NavBar__back')} onClick={this.props.onBack}>
          <span className={cx('NavBar__back-icon')}>
            <BackIcon width={16} height={16} />
          </span>
          <Heading className={cx('NavBar__back-label')} tagName="span" level={4}>
            {this.props.backText}
          </Heading>
        </Heading>
        {totalPrice > 0 && (
          <div className={cx('NavBar__total')}>
            <FormattedMessage id="label.total" />: <Amount value={totalPrice} size="s" />
          </div>
        )}
      </div>
    );
  }
}

export default NavBar;
